import axios from 'axios';
import { installAutoErrorToast } from '../utils/apiError';
import { getAccessToken, refreshAccessToken } from '../auth/token';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const api = axios.create({
  baseURL: `${API_URL}/api/v1/goodday`,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Normalize URLs to avoid double /api prefixes or mismatched controller prefixes
  // since baseURL is already `${API_URL}/api/v1/goodday`
  if (config.url) {
    if (config.url.startsWith('/api/accounting/payment-schedules')) {
      config.url = config.url.replace('/api/accounting/payment-schedules', '/payment-schedules');
    } else if (config.url.startsWith('/accounting/payment-schedules')) {
      config.url = config.url.replace('/accounting/payment-schedules', '/payment-schedules');
    } else if (config.url.startsWith('/api/')) {
      config.url = config.url.replace(/^\/api/, '');
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const isAuthUrl = /\/auth\/(login|register|refresh)$/.test(originalRequest?.url || '');

    if (error.response?.status === 401 && originalRequest && !isAuthUrl && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newToken = await refreshAccessToken();
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return api(originalRequest);
      } catch {
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

// Same rule as every other API client in this app — see
// installAutoErrorToast's doc comment in shared/utils/apiError.ts.
installAutoErrorToast(api);

// getApiErrorMessage used to be duplicated here with a slightly different
// signature; callers now import the one canonical version from
// shared/utils/apiError.ts instead.
export { getApiErrorMessage } from '../utils/apiError';

